/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Block Group Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 07:28:04 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockGroupList = Loadable({
    loader: () => import('../containers/BlockGroups/BlockGroupListContainer'),
    loading: Loading,
});

export const BlockGroupForm = Loadable({
    loader: () => import('../containers/BlockGroups/BlockGroupEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockGroups.js